import React from 'react';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';

const SubmissionRequirements = () => {
  return (
    <div className="min-h-screen bg-[#05339c] flex flex-col">
      <PublicNav />
      <div className="flex-grow container mx-auto px-6 py-32">
        <div className="max-w-3xl mx-auto bg-dark-blue p-8 rounded-2xl border-2 border-yellow">
          <h1 className="text-3xl font-semibold text-center mb-8 text-yellow">
            متطلبات التسليم
          </h1>
          
          <div className="space-y-6 text-right" dir="rtl">
            <p className="text-white text-lg mb-6">
              لضمان قبول مشروعكم، يرجى التأكد من توفر المعلومات التالية في نموذج التسليم:
            </p>
            
            <ul className="space-y-4 pr-4 text-white">
              <li className="text-lg">
                <span className="font-bold text-xl text-red-500 ml-2">*</span>
                <span className="font-semibold text-yellow ml-2">البريد الإلكتروني لقائد الفريق:</span>
                البريد الذي قام قائد الفريق بتسجيل الفريق به.
              </li>
              <li className="text-lg">
                <span className="font-bold text-xl text-red-500 ml-2">*</span>
                <span className="font-semibold text-yellow ml-2">رابط مستودع المشروع (GitHub Repo):</span>
                يجب أن يكون الكود متاحاً للمراجعة.
              </li>
              <li className="text-lg">
                <span className="font-bold text-xl text-red-500 ml-2">*</span>
                <span className="font-semibold text-yellow ml-2">فيديو تعريفي للمشروع:</span>
                فيديو قصير يشرح فكرة المشروع وطريقة عمله.
              </li>
              <li className="text-lg">
                <span className="font-semibold text-yellow ml-2">رابط الديمو (Demo):</span>
                (إن وجد) رابط لتجربة المشروع بشكل مباشر.
              </li>
            </ul>
            <p className="text-white text-sm mb-6 px-4">
                علامة <span className="font-bold text-xl text-red-500 ml-2">*</span> تعني أن الحقل مطلوب.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SubmissionRequirements;

